import { browser } from '../../../../common/services/browser';
import * as banners from '../../../../modules/banners';
import * as call from '../../../../modules/call';
import * as core from '../../../../modules/core';
import * as devices from '../../../../modules/devices';
import * as localMedia from '../../../../modules/local-media';
import { VideoProviderEvents } from '../../../../providers/video';
import { MediaModes, } from '../../../../providers/video/abstract-video-provider';
/* @ngInject */
export default class SelfVideoFrameMiniController {
    constructor($element, VideoProviderFactory, $timeout, $scope, modalsService, flipCamera, $translate, trackingFactory, $ngRedux, $state, globalUi) {
        this.$element = $element;
        this.VideoProviderFactory = VideoProviderFactory;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.modalsService = modalsService;
        this.flipCamera = flipCamera;
        this.$translate = $translate;
        this.trackingFactory = trackingFactory;
        this.$ngRedux = $ngRedux;
        this.$state = $state;
        this.globalUi = globalUi;
        this.MOBILE_AUTO_HIDE_NPI_INFO_DELAY = 5000;
        this.selfPublisherErrorVariant = call.constants.CallFrameVariant.Mini;
        this.showNetworkScore = false;
        this.stats = {};
        this.unsubscribeFromStore = this.$ngRedux.connect(this.mapStateToThis.bind(this))(this);
        VideoProviderFactory.decorateScope(this);
        this.checkIn = globalUi.ui.checkIn;
    }
    $onInit() {
        this.$scope.$watch(() => this.withVideo, () => {
            if (this.withVideo) {
                this.$element[0]
                    .querySelector('.call-frames__append-video')
                    .append(document.querySelector(`#${this.videoPublisherId}`));
            }
        });
        this.activeVideoProvider.on(VideoProviderEvents.PublisherMOSUpdate, (stats) => {
            const publisher = this.activeVideoProvider.getPublisher();
            if (publisher?.guid() === stats.publisher.guid()) {
                this.stats =
                    stats.videoScore.score > 0 ? stats.videoScore : stats.audioScore;
            }
        });
    }
    focusSelfPreviewMenuButton() {
        void this.$timeout(() => {
            const btn = this.$element[0].querySelector('#self-video__menu-button');
            btn?.focus();
        }, 0);
    }
    openVideoSettingsModal() {
        this.modalsService.open('videoSettings', {
            header: this.$translate.instant('video-settings.header'),
            isPatient: this.isPatient,
        });
    }
    pin() {
        this.trackingFactory.global.trackButtonClick({
            button_action: 'pin user',
            button_text: 'pin to the main screen',
            button_type: 'button',
        });
        this.onSelect();
    }
    showNPI() {
        return (this.activeVideoProvider.isInCall &&
            this.activeVideoProvider.getMediaMode() !== MediaModes.ROUTED &&
            (this.hasAudio || this.hasVideo) &&
            this.stats.estimation);
    }
    isMobile() {
        return browser.isMobileScreen();
    }
    handleOutsideNPIClick() {
        if (this.npiHideTimeout) {
            this.$timeout.cancel(this.npiHideTimeout);
        }
        this.showNetworkScore = false;
    }
    npiMouseEnter() {
        if (!this.isMobile()) {
            this.showNetworkScore = true;
        }
    }
    npiMouseLeave() {
        if (!this.isMobile()) {
            this.showNetworkScore = false;
        }
    }
    clickNPI(event) {
        if (!this.isMobile()) {
            return;
        }
        event?.stopPropagation();
        if (this.npiHideTimeout) {
            this.$timeout.cancel(this.npiHideTimeout);
        }
        this.npiHideTimeout = this.$timeout(() => {
            this.showNetworkScore = false;
        }, this.MOBILE_AUTO_HIDE_NPI_INFO_DELAY);
        this.showNetworkScore = !this.showNetworkScore;
    }
    unpin() {
        this.onSelect();
    }
    toggleVideo(isEnabled) {
        this.$ngRedux.dispatch(localMedia.actions.toggleVideo(isEnabled));
    }
    toggleAudio(isEnabled) {
        this.$ngRedux.dispatch(localMedia.actions.toggleAudio(isEnabled));
    }
    switchCamera() {
        this.flipCamera();
    }
    get canSeeBackgroundEffects() {
        return core.canSeeBackgroundEffects();
    }
    openBackgroundEffectsModal() {
        this.$ngRedux.dispatch(core.actions.openBackgroundEffectsModal('self preview'));
    }
    hidePreview() {
        this.$ngRedux.dispatch(call.actions.hideSelfPreview());
        if (this.$state.$current.name === 'account.dashboard' &&
            !this.VideoProviderFactory.activeProvider.isInCall) {
            this.trackingFactory.global.trackButtonClick({
                button_action: 'hide user preview',
                button_text: 'hide my preview',
                button_type: 'button',
                context: 'dashboard',
            });
        }
    }
    get isBackgroundEffectsBannerVisible() {
        return (core.canUseBackgroundEffects() &&
            this.wasBackgroundBannerNotSeen &&
            !this.activeVideoProvider.isInCall);
    }
    closeBackgroundEffectsBanner() {
        if (core.canUseBackgroundEffects() && this.wasBackgroundBannerNotSeen) {
            this.$ngRedux.dispatch(banners.actions.acknowledge('backgroundEffects', 'main'));
        }
    }
    mapStateToThis(state) {
        return {
            hasCameraAccess: devices.selectors.hasCameraAccess(state),
            hasMicrophoneAccess: devices.selectors.hasMicrophoneAccess(state),
            hasMediaAccess: devices.selectors.hasMediaAccess(state),
            hasMicrophoneAccessOnly: devices.selectors.hasMicrophoneAccessOnly(state),
            hasVideo: localMedia.selectors.hasVideo(state),
            hasAudio: localMedia.selectors.hasAudio(state),
            isFlipCameraAvailable: localMedia.selectors.selectFlipCameraAvailability(state),
            isFlipCameraAvailableOnMobile: localMedia.selectors.selectFlipCameraAvailabilityOnMobile(state),
            wasBackgroundBannerNotSeen: banners.selectors.wasBackgroundBannerNotSeen(state),
        };
    }
    $onDestroy() {
        this.unsubscribeFromStore();
    }
}
